






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MpCard from '@/components/controls/mp-card/MpCard.vue';
import moment, { min } from 'moment';
import { Bundle } from '@/connectors/bundles/bundle.model';
import { BundleStatistics } from '@/connectors/bundles/bundle-statistics.model';
import { KeyValuePair } from '@/connectors/kvp.model';
@Component({
  components: { MpCard }
})
export default class MpBundleViewsByDateChartCard extends Vue {
  de = require('apexcharts/dist/locales/de.json');

  @Prop()
  value!: BundleStatistics;

  @Prop({ default: '' })
  height!: string;

  @Prop()
  bundle!: Bundle;

  // Array<KeyValuePair<string, number>>

  selectableBundleItems: Array<KeyValuePair<string, { id: string; value: Array<KeyValuePair<Date, number>> }>> = [];
  selectedBundleItem: KeyValuePair<string, { id: string; value: Array<KeyValuePair<Date, number>> }> | null = null;

  maxDate: string = '';
  minDate: string = '';

  get chartHeight(): number {
    return parseInt(this.height, 10) - 43;
  }

  isReady: boolean = false;

  chartOptions: any = {
    chart: {
      events: {
        mounted: (chart: any) => {
          if (
            !!chart &&
            !!chart.w &&
            !!chart.w.config &&
            !!chart.w.config.xaxis &&
            !!chart.w.config.xaxis.min &&
            !!chart.w.config.xaxis.max
          ) {
            this.updateMinMaxLabels(
              moment(chart.w.config.xaxis.min).format('DD.MM.YYYY'),
              moment(chart.w.config.xaxis.max).format('DD.MM.YYYY')
            );
          } else {
            this.updateMinMaxLabels(null, null);
          }
        },
        updated: (chart: any) => {
          if (
            !!chart &&
            !!chart.w &&
            !!chart.w.config &&
            !!chart.w.config.xaxis &&
            !!chart.w.config.xaxis.min &&
            !!chart.w.config.xaxis.max
          ) {
            this.updateMinMaxLabels(
              moment(chart.w.config.xaxis.min).format('DD.MM.YYYY'),
              moment(chart.w.config.xaxis.max).format('DD.MM.YYYY')
            );
          } else {
            this.updateMinMaxLabels(null, null);
          }
        }
      },
      locales: [this.de],
      defaultLocale: 'de',
      toolbar: {
        show: true
      }
    },
    theme: {
      monochrome: {
        enabled: true,
        color: '#589bad',
        shadeTo: 'dark',
        shadeIntensity: 0.65
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      // categories: this.labels,
      tickAmount: 1,
      type: 'datetime',
      min: undefined,
      max: undefined,
      labels: {
        style: {
          colors: ['#589bad'],
          fontSize: '13px'
        }
        // formatter(d: Date) {
        //   return moment(d).format('DD MMM YY');
        // }
      }
    },
    yaxis: {
      labels: {
        offsetX: -5,
        formatter: (i: number) => {
          return !!i
            ? i.toLocaleString('de-DE', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              })
            : 0;
        },
        style: {
          color: '#589bad',
          fontSize: '12px'
          // fontFamily: 'Montserrat, sans-serif'
        }
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        endingShape: 'flat',
        columnWidth: '85%',
        barHeight: '85%',
        distributed: false
      }
    },
    tooltip: {
      theme: 'dark',
      style: {
        fontSize: '16px',
        fontFamily: 'Montserrat, sans-serif'
      },
      onDatasetHover: {
        highlightDataSeries: true
      },
      marker: {
        show: true
      }
    },
    grid: {
      show: true,
      borderColor: 'transparent'
    }
  };

  labels: any[] = [];

  series: any[] = [];

  updateMinMaxLabels(minDate: string | null, maxDate: string | null) {
    if (!!minDate && !!maxDate) {
      this.minDate = minDate;
      this.maxDate = maxDate;
    } else {
      const orderedDates = this.value.completedByDate
        .map(v => v.key)
        .sort((a: any, b: any) => {
          return new Date(b).getTime() / 1000 - new Date(a).getTime() / 1000;
        });

      if (!!orderedDates && orderedDates.length > 0) {
        this.maxDate = moment(orderedDates[0]).format('DD.MM.YYYY');
        this.minDate = moment(orderedDates[orderedDates.length - 1]).format('DD.MM.YYYY');
      }
    }
  }

  @Watch('value')
  onValueChanged() {
    this.series = [];

    this.buildSelection();
    this.onSelectionChanged();
  }

  onSelectionChanged() {
    if (!this.selectedBundleItem || !this.selectedBundleItem.value || !this.selectedBundleItem.value.value) {
      return;
    }

    this.isReady = false;
    this.series = [];

    this.series.push({
      name: 'views',
      data: this.selectedBundleItem.value.value.map(s => {
        return {
          y: s.value,
          x: moment(s.key).format('MM-DD-YYYY')
        };
      })
    });

    this.isReady = true;
  }

  buildSelection() {
    let indexToSelect = 0;

    if (this.selectedBundleItem) {
      indexToSelect = this.selectableBundleItems.indexOf(this.selectedBundleItem);
    }

    this.selectableBundleItems = [];

    this.selectableBundleItems.push({
      key: 'Views gesamt',
      value: { id: this.bundle.id, value: this.value.completedByDate }
    });

    if (!!this.value.videoStatistics && this.value.videoStatistics.length > 1) {
      this.value.videoStatistics.forEach(vs =>
        this.selectableBundleItems.push({
          key: vs.name,
          value: {
            id: vs.bundleItemId,
            value: vs.completedByDate
          }
        })
      );
    }

    this.selectedBundleItem = this.selectableBundleItems[indexToSelect];
  }

  async mounted() {
    this.series = [];

    this.buildSelection();
    this.onSelectionChanged();
  }
}
